import $ from 'jquery';
import _ from 'underscore';
import run from '../../utilities/run';
import render from "../../utilities/render";
import {setElementsFromScope, setOptionsForSelect} from "../../utilities/selectorHelpers";

require("./standardPlatformFacilitySetupWizard.less");
// Additional Imports...

const modalHtml = require("../../sharedHtml/modal.html");
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";

const elementsMap = {
   addresstabfaccountry :"#fac-address-tab-country",
   addresstabfacaddress1:"#fac-address-tab-address1",
   addresstabfacaddress2:"#fac-address-tab-address2",
   addresstabfaccity:"#fac-address-tab-city",
   addresstabfacstate:"#fac-address-tab-state",
   addresstabfacstatetext:"#fac-address-tab-stateText",
   addresstabfaczipcode: "#fac-address-tab-zip",
   addresstabfactimezone:"#fac-address-tab-timezone",
   addresstabfaccontactname: "#fac-address-tab-contact-name",
   addresstabfacphonecode:"#fac-address-tab-phone-code",
   addresstabfacphonenumber:"#fac-address-tab-phone"
}
let els = {};

export default function AdrressTab(wizard){
  const self = this;
  const wizardEl = wizard.getWizardElement();

  const addressTabCountrySelect = $("#fac-address-tab-country");
  const countries = wizardEl.data("countries");
  const defaultCountry = addressTabCountrySelect.data("default-country");
  const addressTabStatesSelect = $("#fac-address-tab-state");
  const mandatoryLabel = wizardEl.find(".mandatory-label");
  const usaStates = wizardEl.data("us-states");
  const caProvinces = wizardEl.data("ca-provinces");
  const countriesPhoneCodeSelect = $("#fac-address-tab-phone-code");
  const countriesPhoneCodeList = wizardEl.data("phone-code-list");
  const phoneNumber = $("#fac-address-tab-phone");
  const addressTabTimeZonesSelect = $("#fac-address-tab-timezone");
  const timeZones = wizardEl.data("time-zones");
  const addressTabStateTextDiv = wizardEl.find(".address-tab-stateText-wrapper");
  const addressTabStateDiv = wizardEl.find(".address-tab-state-wrapper");
  const addressTabZipCode = wizardEl.find("#fac-address-tab-zip");
  const addressTabTimeZoneDiv = wizardEl.find(".address-tab-timezone-wrapper");
  const addressTabEmail = wizardEl.find("#fac-address-tab-email");
  const facData = wizardEl.data("load-edit-facility");
  const validationReqdCountries = wizardEl.data("validation-reqd-countries");
  let countryId;


  self.init = function(){
    setElements(); 
    loadCountriesList();
    handleSwitchingStateInput();
    loadCountriesPhoneCodeList();
    setPhoneNumberInputMask();
    addressTabCountrySelect.on('change', handleSwitchingStateInput);
    countriesPhoneCodeSelect.on('change', phoneCodeChange)
    loadTimeZones();
    loadAddressEditForm();
  }
  function setElements(){
    setElementsFromScope(els, elementsMap, wizardEl);
  }

  function loadCountriesList(){
    setOptionsForSelect({
	    	selectElement: addressTabCountrySelect,
	    	list: countries,
	    	valueDataKey: "conId",
	    	textDataKey: "conName"
	  	});
      // set default as USA from defaultCountry value
      addressTabCountrySelect.val(defaultCountry);
  }

  function handleSwitchingStateInput(){
    let countryVal = addressTabCountrySelect.find(":selected").val();
    let isValidCountry =false;
    let countryValue='';
    let checkZipCode = false;
    $(countries).each(function() {
      if(this.conId.toString() === countryVal.toString()) {
        countryId = this.conPhoneCode.toString();
        countryValue = this.conCode;
        if(this.conPostalCodeRequired.toString() === "Y"){
          checkZipCode=true;
        }
        return false;
      } 
    });
    if(countryVal === "1"){
      $(".fac-address-tab-phone-code option").filter(function() {
        let text= $(this).text().toString();
        return text === "United States of America +1";
    }).prop("selected", true).trigger("change");
    }else if(countryVal === "2"){
      $(".fac-address-tab-phone-code option").filter(function() {
        let text= $(this).text().toString();
        return text === "Canada +1";
    }).prop("selected", true).trigger("change");
    }else if(countryVal === "3"){
      $(".fac-address-tab-phone-code option").filter(function() {
        let text= $(this).text().toString();
        return text === "United States Minor Outlying Islands +1";
    }).prop("selected", true).trigger("change");
    }else{
      $(".fac-address-tab-phone-code option").filter(function() {
        let text= $(this).val().toString();
        return text === countryId.toString();
    }).prop("selected", true).trigger("change");
    }
    if(countryVal == "1" || countryVal == "2") {
			addressTabStateTextDiv.hide();
			addressTabStateDiv.show();
			setStates(countryVal);
      mandatoryLabel.show();
      // show timeZones only if US or Canada
      addressTabTimeZoneDiv.show();
      addressTabZipCode.prop('required', true);
      setMasks();
		} else {
			addressTabStateTextDiv.show();
			addressTabStateDiv.hide();
      addressTabTimeZoneDiv.hide();
      mandatoryLabel.hide();
      addressTabZipCode.prop('required', false);
      setUnMasks();
    }
    
    $(validationReqdCountries).each(function() {
      if(this.cdmValue.toString() === countryValue.toString()) {
        isValidCountry = true;
        return false;
      } 
    });
    if(isValidCountry){
      $(".country-not-supported-facility").hide();        
    }else{
      $(".country-not-supported-facility").show();
    }
    const postalCode = $(".fac-address-tab-zip");
    const postalCodeLabel = $(".facility-zip-label");
    if(checkZipCode){
      postalCodeLabel.text('Postal Code *');
      postalCode.addClass('required');
      postalCode.prop('required',true);
    }else{
      postalCodeLabel.text('Postal Code');
      postalCode.removeClass('required');
      postalCode.prop('required',false);
    }
  }

  function setMasks() {
    $('.fac-address-tab-phone').attr("placeholder", "(999) 999-9999");
    $('.fac-address-tab-phone').inputmask({
      mask: "(999) 999-9999"
    });
  }
  
  function setUnMasks() {
    $('.fac-address-tab-phone').removeClass("phoneUS");
    $('.fac-address-tab-phone').attr("placeholder", "");
    $('.fac-address-tab-phone').inputmask({
      mask: ""
    }); 
    let val= $('.fac-address-tab-phone').val();
      if(val){
      let v=   val.replace(/[- )(]/g,'');
         $('.fac-address-tab-phone').val(v);
       }
  }

  function phoneCodeChange(){
    let phonecode= $(".fac-address-tab-phone-code").val().toString();
    if( phonecode === '+1'){
      setMasks();
    }else{
      setUnMasks();
    } 
  }
  
  function setStates(countryVal){
    // re-initialize states dropdown on every call
    addressTabStatesSelect.html('');
		if(countryVal == "1") {
      setOptionsForSelect({
  	    	selectElement: addressTabStatesSelect,
  	    	list: usaStates,
  	    	valueDataKey: "cdmValue",
  	    	textDataKey: "cdmMeaning"
  	  	});
		} else if(countryVal == "2") {
      setOptionsForSelect({
  	    	selectElement: addressTabStatesSelect,
  	    	list: caProvinces,
  	    	valueDataKey: "cdmValue",
  	    	textDataKey: "cdmMeaning"
  	  	});
		}
	}

  function loadCountriesPhoneCodeList(){
    setOptionsForSelect({
	    	selectElement: countriesPhoneCodeSelect,
	    	list: countriesPhoneCodeList,
	    	valueDataKey: "conPhoneCode",
	    	textDataKey: "conPhoneText"
	  	});
      // set US Phone code as default
      countriesPhoneCodeSelect.val("+1");
  }

  // validate the phoneNumber for "+1" phone code
  //phoneNumber.on('focusout', function(e){
    //setPhoneCodeValidation($(this).val());
  //});

  function setPhoneCodeValidation(data){
		if(countriesPhoneCodeSelect.val()=="+1"){
			phoneNumber.addClass("phoneUS");
		}else{
			phoneNumber.removeClass("phoneUS");
		}
	}

  // add the mask to phoneNumber
  function setPhoneNumberInputMask(){
    phoneNumber.inputmask({
      mask: "(999) 999-9999"
    });
	}

  // validate email address
  addressTabEmail.on('focusout', function(e){
    addressTabEmail.addClass("pattern");
  });

  function loadTimeZones(){
    setOptionsForSelect({
	    	selectElement: addressTabTimeZonesSelect,
	    	list: timeZones,
	    	valueDataKey: "cdmValue",
	    	textDataKey: "cdmMeaning"
	  	});
  }

  function loadAddressEditForm(){
    if(facData != null && facData != ''){
      if(facData.facAddressLine1 != null){
        els.addresstabfacaddress1.val(facData.facAddressLine1);
      }
      if(facData.facAddressLine2 != null){
        els.addresstabfacaddress2.val(facData.facAddressLine2);
      }
      if(facData.facCity != null){
        els.addresstabfaccity.val(facData.facCity);
      }
      if(facData.facZipcode != null){
        els.addresstabfaczipcode.val(facData.facZipcode);
      }
      if(facData.facPhoneCode != null){
        els.addresstabfacphonecode.val(facData.facPhoneCode);
      }
      if(facData.facContactPhone != null){
        els.addresstabfacphonenumber.val(facData.facContactPhone);
      }
      if(facData.facContactName != null){
        els.addresstabfaccontactname.val(facData.facContactName);
      }
      if(facData.facContactEmail != null){
        addressTabEmail.val(facData.facContactEmail); 
      }

      addressTabCountrySelect.find('option[value='+facData.facCountry+']').prop('selected', 'selected').trigger('change'); 
     if(facData.facCountry == "1" || facData.facCountry == "2"
          || facData.facCountry == "US" || facData.facCountry == "CA") {
        els.addresstabfacstate.find('option[value='+facData.facState+']').prop('selected', 'selected').trigger('change'); 
      } else {
        els.addresstabfacstatetext.val(facData.facState);
      }

      if(facData.facTimeZone != null){      
       addressTabTimeZonesSelect.val(facData.facTimeZone).trigger('change');        
      }

      if(facData.facPhoneCode != null){
        countriesPhoneCodeSelect.val(facData.facPhoneCode);
      }
    }
  }


 


}



// WEBPACK FOOTER //
// ./src/pages/standardPlatformFacilitySetupWizard/addressTab.js